export default __webpack_public_path__ + "static/menu-do-dark-dd162a1d162a69d6931ddcbb2f9a4aa3.png";